import { Skeleton as MuiSkeleton, SkeletonProps } from "@mui/material";
import { withDisplayName } from "../../utils/displayName";

export const SkeletonVariants = ["text", "rectangular", "rounded", "circular"];

withDisplayName(MuiSkeleton, "Skeleton");
export default MuiSkeleton;
export type { SkeletonProps };
